import React from "react";
import { Box } from "@mui/material";
import VerticalStreamCarousel from "./VerticalStreamCouressel";

const MyDashboardDashboard: React.FC = () => {
  return (
    <Box>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "flex-start", // Aligns content to the left
          alignItems: "flex-start", // Aligns content to the top
          width: "100%",
        }}
      >
        <VerticalStreamCarousel />
      </Box>
    </Box>
  );
};

export default MyDashboardDashboard;
